const state = {
  title: '',
  items: []
}

const getters = {
  getTitle: state => state.title,
  getItems: state => state.items
}

const mutations = {
  UPDATE_TITLE: (state, string) => {
    state.title = string
  },
  UPDATE_ITEMS: (state, items) => {
    state.items = [ ...items ]
  }
}

const actions = {
  updateTitle: ({ commit }, title) => {
    commit('UPDATE_TITLE', title)
  },
  updateItems: ({ commit }, items) => {
    commit('UPDATE_ITEMS', items)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
